import {
    Component,
    OnInit
}
    from '@angular/core';

import {
    CommonModule,
    NgIf,
    ViewportScroller
}
    from '@angular/common';

import {
    FormsModule
}
    from '@angular/forms';

import {
    Router
}
    from '@angular/router';

import {
    BeesFooterComponent
}
    from "../bees-footer/bees-footer.component";

import {
    BeesHeaderComponent
}
    from "../bees-header/bees-header.component";

import {
    FlyingbeesService
}
    from '../flyingbees.service';

@Component({

    selector:
        'app-page-agricultural',

    standalone: true,

    imports: [

        CommonModule,

        FormsModule,

        NgIf,

        BeesFooterComponent,

        BeesHeaderComponent

    ],

    templateUrl:
        './page-agricultural.component.html',

    styleUrls: [
        './page-agricultural.component.scss'
    ]

})

export class PageAgriculturalComponent
    implements OnInit {

    activeSection =
        'cashew';

    showPopup =
        true;

    pin1 = '';
    pin2 = '';
    pin3 = '';
    pin4 = '';

    errorMsg = '';

    constructor(

        private scroller:
            ViewportScroller,

        private manas:
            FlyingbeesService,

        private router:
            Router

    ) { }

    /* INIT */

    ngOnInit() {

        const access =

            localStorage.getItem(
                'page_access'
            );

        if (
            access === 'true'
        ) {

            this.showPopup =
                false;

        }

    }

    /* SCROLL */

    goToSection(
        section: string
    ) {

        this.activeSection =
            section;

        this.scroller
            .scrollToAnchor(
                section
            );

    }

    /* OTP */

    moveNext(

        event: any,

        next?:
            HTMLInputElement

    ) {

        if (
            event.target.value
            &&
            next
        ) {

            next.focus();

        }

        const code =

            this.pin1 +

            this.pin2 +

            this.pin3 +

            this.pin4;

        if (
            code.length === 4
        ) {

            this.checkPassword();

        }

    }

    /* PASSWORD */

    checkPassword() {

        const code =

            this.pin1 +

            this.pin2 +

            this.pin3 +

            this.pin4;

        this.errorMsg = '';

        this.manas

            .CheckPassword(
                code
            )

            .subscribe({

                next: (res: any) => {

                    console.log(
                        res
                    );

                    if (
                        res.status === 'success'
                    ) {

                        this.showPopup =
                            false;

                        localStorage.setItem(

                            'page_access',

                            'true'

                        );

                    }
                    else {

                        this.errorMsg =

                            'Invalid Password';

                        this.clearPin();

                        this.showPopup =
                            true;

                    }

                },

                error: (err) => {

                    console.log(
                        err
                    );

                    this.errorMsg =

                        'Server Error';

                    this.clearPin();

                    this.showPopup =
                        true;

                }

            });

    }

    /* CLEAR */

    clearPin() {

        this.pin1 = '';

        this.pin2 = '';

        this.pin3 = '';

        this.pin4 = '';

    }

    /* HOME */

    goHome() {

        this.router.navigate(
            ['/']
        );

    }

}